/* eslint-disable react/no-did-update-set-state */

import React from 'react';
import PropTypes from 'prop-types';

import Select from './Select';
import SelectOption from './SelectOption';


import { STATES, TERRITORIES, ARMED_FORCES } from '../../../constants';

export default class StatePicker extends React.PureComponent {
    static propTypes = {
        /** html id required to connect the select with the label */
        id: PropTypes.string.isRequired,

        /** Label contents, usually text */
        label: PropTypes.string,

        /** Include territories such as American Samoa */
        hasTerritories: PropTypes.bool,

        /** Include armed forces options for APO/FPO addresses */
        hasArmedForces: PropTypes.bool,

        /** Text of placeholder */
        placeholder: PropTypes.string
    };

    static defaultProps = {
        label: 'State',
        hasTerritories: true,
        hasArmedForces: true,
        placeholder: 'Choose a state ...'
    };

    constructor(props) {
        super(props);

        this.state = {
            stateOptions: this.getStateOptions()
        };

        this.selectRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        const { hasTerritories, hasArmedForces } = this.props;
        if (
            (prevProps.hasTerritories !== hasTerritories) ||
            (prevProps.hasArmedForces !== hasArmedForces)
        ) {
            this.setState({
                stateOptions: this.getStateOptions()
            })
        }
    }

    getStateOptions = () => {
        const { hasTerritories, hasArmedForces } = this.props;

        let stateOptions = [...STATES];

        if (hasTerritories) {
            stateOptions = [
                ...stateOptions,
                ...TERRITORIES
            ];
        }

        if (hasArmedForces) {
            stateOptions = [
                ...stateOptions,
                ...ARMED_FORCES
            ]
        }

        return stateOptions.sort((a, b) => {
            if (a.label < b.label) {
                return -1
            }
            else if (a.label > b.label) {
                return 1
            }
            return 0;
        });
    }

    validate = () => {
        return this.selectRef.current.validate();
    }

    render() {
        const {
            label,
            id,
            hasTerritories,
            hasArmedForces,
            ...rest
        } = this.props;

        const { stateOptions } = this.state;

        return (
            <Select
                ref={this.selectRef}
                label={label}
                id={id}
                {...rest}>
                {stateOptions.map((option) => (
                    <SelectOption
                        key={option.value}
                        value={option.value}>
                        {option.label}
                    </SelectOption>
                ))}
            </Select>
        );
    }
}
